import { Badge, Card, Text } from "@merge-api/merge-javascript-shared";
import { ExternalLink } from "lucide-react";
import { getBlueprintEditorPath } from "../../../router/RouterUtils";
import { BlueprintDisplay } from "./types";

const BlueprintCard = ({
  bp,
  integrationID,
  isInitialOverride,
}: {
  bp: BlueprintDisplay;
  integrationID: string;
  isInitialOverride?: boolean;
}) => {
  const displayName = bp.humanName || bp.name || bp.id.slice(0, 8);
  const editorPath = bp.publishedVersionId
    ? getBlueprintEditorPath(integrationID, bp.publishedVersionId)
    : null;

  return (
    <Card
      className={`px-4 py-3 flex flex-col gap-1.5 min-w-[200px] ${
        !bp.publishedVersionId ? "opacity-50" : ""
      }`}
    >
      <div className="flex items-start justify-between gap-2">
        <Text variant="sm" className="font-semibold text-gray-800">
          {displayName}
        </Text>
        {!bp.publishedVersionId && (
          <Badge color="gray" className="flex-none">
            unpublished; will not run
          </Badge>
        )}
      </div>
      <div className="flex items-end justify-between gap-2 mt-0.5">
        {editorPath ? (
          <a
            href={editorPath}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-1 text-xs text-blue-600 hover:text-blue-800 font-medium"
          >
            Open in editor <ExternalLink size={11} />
          </a>
        ) : (
          <span />
        )}
        {isInitialOverride && (
          <Badge color="blue" className="flex-none">
            initial sync override
          </Badge>
        )}
      </div>
    </Card>
  );
};

export default BlueprintCard;
